module.exports = __webpack_public_path__ + "img/university_3.f20f2d90.jpg";